import * as React from 'react';

import cn from 'classnames';

import { Translate } from '@decorators';

import { MultilineText } from '@common/components/MultilineText';

import {
	EBrandFileName,
	EBrandImage,
} from '../../enums';
import { IBrandPageProps } from '../../types';
import { BrandBlock } from '../BrandBlock';

import * as s from './BrandBlockScreen.scss';

@Translate('common.containers.Brand.components.BrandBlockScreen')
export class BrandBlockScreen extends React.Component<IBrandPageProps> {

	render() {
		const {
			isMobile,
			brand,
			urls: {
				brandDownload,
				imagePath,
			},
			classNames: {
				bigCard: bigCardClassName,
			},
			onDownloadButtonClick,
		} = this.props;

		return (
			<div className={s.block}>
				<div className={s.notice}>
					<MultilineText text={this.t('description')}/>
				</div>

				<BrandBlock
					title={this.t('mainVersion')}
					downloadTitle={this.t('download')}
					downloadFileSize={isMobile ? null : brand.fileSizes.block.main}
					downloadLinkUrl={`${brandDownload}/${EBrandFileName.BLOCK_MAIN}.zip`}
					classNames={{
						block: s.brandBlock,
						content: s.blockContent,
					}}
					onDownloadButtonClick={onDownloadButtonClick}
				>
					<div className={cn(s.card, bigCardClassName)} style={{
						backgroundImage: `url(${imagePath}/${EBrandImage.BLOCK_MAIN}.png)`,
					}}/>
				</BrandBlock>

				<BrandBlock
					title={this.t('alternativeVersion')}
					downloadTitle={this.t('download')}
					downloadFileSize={isMobile ? null : brand.fileSizes.block.alternative}
					downloadLinkUrl={`${brandDownload}/${EBrandFileName.BLOCK_ALTERNATIVE}.zip`}
					classNames={{
						content: s.blockContent,
					}}
					onDownloadButtonClick={onDownloadButtonClick}
				>
					<div className={cn(s.card, bigCardClassName)} style={{
						backgroundImage: `url(${imagePath}/${EBrandImage.BLOCK_ALTERNATIVE}.png)`,
					}}/>
				</BrandBlock>
			</div>
		);
	}

}
